module.exports = __webpack_public_path__ + "img/receptionist.941d925e.jpg";